import { useState } from 'react';

interface FaqItem {
  question: string;
  answer: string;
}

const faqData: FaqItem[] = [
  {
    question: '黄瓜影院是否需要注册才能观看？',
    answer: '不需要！黄瓜影院所有影视资源完全免费，无需注册、无需登录，打开即可在线观看。我们致力于为用户提供最便捷的观影体验。',
  },
  {
    question: '黄瓜影院的画质如何？支持哪些清晰度？',
    answer: '黄瓜影院提供高清、超清甚至4K画质选项，支持多种清晰度自由切换。我们会根据您的网络状况推荐最适合的清晰度，确保流畅观影。',
  },
  {
    question: '黄瓜影院的影视资源多久更新一次？',
    answer: '我们的内容团队每天更新最新影视资源，热门电影、电视剧上线后24小时内即可在黄瓜影院观看。综艺节目和动漫也会在播出后第一时间更新。',
  },
  {
    question: '黄瓜影院支持哪些设备观看？',
    answer: '黄瓜影院全面支持电脑、平板、手机等多种设备。无论是在家里用大屏电视，还是通勤路上用手机，都能流畅观看您喜爱的影视内容。',
  },
  {
    question: '黄瓜影院的资源是否正版？',
    answer: '黄瓜影院收录的资源均来自互联网公开分享的内容，仅供学习交流使用。如涉及版权问题，请及时联系我们进行处理。',
  },
];

export default function HomeFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">
            关于黄瓜影院的常见疑问，这里都有解答
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
                onClick={() => toggleFaq(index)}
              >
                <span className="font-heading text-sm md:text-base font-semibold text-foreground-950 pr-4">
                  {faq.question}
                </span>
                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-${
                      openIndex === index ? 'subtract-line' : 'add-line'
                    } text-lg text-foreground-500 transition-transform duration-300`}
                  ></i>
                </span>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-[300px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}